import React from 'react';

type Props = {
  fill: string;
  opacity?: string;
  size?: string;
};
function IconHeart(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ?? '32'}
      height={props.size ?? '32'}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill={props.fill}
        fillOpacity={props.opacity || '1.0'}
        d="M21.333 6.667a6.586 6.586 0 00-4.422 1.704 1.342 1.342 0 01-1.822 0 6.586 6.586 0 00-4.422-1.704c-.428 0-.854.04-1.274.12a6.75 6.75 0 00-5.386 6.89c.268 6.23 7.741 10.787 10.753 12.375a2.644 2.644 0 002.48 0c3.012-1.588 10.485-6.145 10.753-12.374a6.75 6.75 0 00-5.386-6.892 6.927 6.927 0 00-1.274-.12z"
      ></path>
    </svg>
  );
}

export const SvgIconHeart = React.memo(IconHeart);
